module.exports = __webpack_public_path__ + "static/media/icon-table-help.9161e0f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-table-help.svg
// module id = 90
// module chunks = 0